module.exports = __webpack_public_path__ + "static/media/iv_close_demat.c9e1361b.svg";